import { FundFamilyEventStateMachineFieldsEnum } from "gen/model/fundFamilyEventStateMachineFieldsEnum";
import { GenericTableBadge } from "gen/model/genericTableBadge";
import { TFunction } from "i18next";

export const getCapitalActivityEventStateBadge = (
  state: FundFamilyEventStateMachineFieldsEnum | undefined | null,
  t: TFunction<["common"]>,
  showCompleted = true,
): GenericTableBadge | undefined => {
  if (!state) {
    return undefined;
  }
  switch (state) {
    case FundFamilyEventStateMachineFieldsEnum.draft:
      return {
        type: "warning",
        text: t("common:draft"),
      };
    case FundFamilyEventStateMachineFieldsEnum.in_progress:
      return {
        type: "cyan",
        text: t("common:inProgress"),
      };
    case FundFamilyEventStateMachineFieldsEnum.completed:
      if (!showCompleted) {
        return undefined;
      }
      return {
        type: "success",
        text: t("common:completed"),
      };
    case FundFamilyEventStateMachineFieldsEnum.out_of_date:
      return {
        type: "error",
        text: t("common:outOfDate"),
      };
  }
  return {
    type: "default",
    text: state,
  };
};
